module.exports = __webpack_public_path__ + "img/43d14d82c174b2b43fdae3b2b6355bd3.png";